const STATUS_META = {
  idle: { color: '#94a3b8', label: 'Idle', icon: 'circle' },
  working: { color: '#38bdf8', label: 'Working', icon: 'loader' },
  blocked: { color: '#f87171', label: 'Blocked', icon: 'ban' },
  escalated: { color: '#fbbf24', label: 'Escalated', icon: 'alert-triangle' },
  done: { color: '#34d399', label: 'Done', icon: 'check-circle' },
  in_progress: { color: '#38bdf8', label: 'In Progress', icon: 'loader' },
  review: { color: '#818cf8', label: 'Review', icon: 'loader' },
  new: { color: '#94a3b8', label: 'New', icon: 'circle' },
  cancelled: { color: '#64748b', label: 'Cancelled', icon: 'x-circle' },
};

const BRANCH_META = {
  Executive: { token: 'exec', color: '#f472b6' },
  Product: { token: 'product', color: '#a78bfa' },
  Engineering: { token: 'eng', color: '#38bdf8' },
  'Sales & Marketing': { token: 'sales', color: '#fbbf24' },
  'Customer Success': { token: 'cs', color: '#34d399' },
  Operations: { token: 'ops', color: '#fb923c' },
  Sales: { token: 'sales', color: '#fbbf24' },
  CS: { token: 'cs', color: '#34d399' },
};

const PRIORITY_META = {
  low: { color: '#64748b', label: 'Low' },
  medium: { color: '#38bdf8', label: 'Medium' },
  high: { color: '#fbbf24', label: 'High' },
  critical: { color: '#f87171', label: 'Critical' },
};

const EVENT_META = {
  handoff: { icon: 'arrow-right', color: '#38bdf8' },
  status_change: { icon: 'refresh-cw', color: '#fbbf24' },
  decision: { icon: 'check-square', color: '#34d399' },
  error: { icon: 'x-circle', color: '#f87171' },
  created: { icon: 'check-square', color: '#34d399' },
  assigned: { icon: 'arrow-right', color: '#38bdf8' },
  status_changed: { icon: 'refresh-cw', color: '#fbbf24' },
  approved: { icon: 'check-circle', color: '#34d399' },
  changes_requested: { icon: 'alert-circle', color: '#f87171' },
  review: { icon: 'eye', color: '#818cf8' },
  update: { icon: 'activity', color: '#94a3b8' },
};

export function getStatusMeta(status) {
  return STATUS_META[status] || { color: '#94a3b8', label: status || 'Unknown', icon: 'circle' };
}

export function getBranchMeta(branch) {
  return BRANCH_META[branch] || { token: 'ops', color: '#fb923c' };
}

export function getPriorityMeta(priority) {
  return PRIORITY_META[priority] || { color: '#94a3b8', label: priority || 'Normal' };
}

export function getEventMeta(eventType) {
  return EVENT_META[eventType] || { icon: 'activity', color: '#94a3b8' };
}

export function formatDate(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(date);
}

export function formatRelativeTime(iso) {
  if (!iso) return '—';
  const date = new Date(iso);
  const now = new Date();
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
}

export function getInitials(name, length = 2) {
  if (!name) return '?';
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, length)
    .map((n) => n[0].toUpperCase())
    .join('');
}

export function clampInbox(count) {
  if (count == null) return 0;
  return count > 99 ? '99+' : String(count);
}

export function classNames(...args) {
  return args
    .flatMap((arg) => {
      if (!arg) return [];
      if (typeof arg === 'string') return arg;
      if (typeof arg === 'object') return Object.entries(arg).filter(([, v]) => Boolean(v)).map(([k]) => k);
      return [];
    })
    .join(' ');
}
